import { createSlice } from "@reduxjs/toolkit";

export const sessionConfigSlice = createSlice({
  name: "sessionConfigSlice",
  initialState: {
    sessionConfig: null,
  },
  reducers: {
    setSessionConfig: (currentSlice, action) => {
      currentSlice.sessionConfig = action.payload;
    },
  },
});

export const { setSessionConfig } = sessionConfigSlice.actions;
export const sessionConfigReducer = sessionConfigSlice.reducer;
